import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'dateDifference',
  standalone: true
})
export class DateDifferencePipe implements PipeTransform {

  transform(date1: string, date2: string): number {
    // const createdOn = new Date(date1);
    const currentDate = new Date();
    const lastUpdatedOn = new Date(date2);

    if (isNaN(currentDate.getTime()) || isNaN(lastUpdatedOn.getTime())) {
      return 0;
    }

    const diffInMs = currentDate.getTime() - lastUpdatedOn.getTime();

    const diffInDays = Math.round(diffInMs / (1000 * 3600 * 24));

    return diffInDays;
  }
}
